// extracted by mini-css-extract-plugin
export var form = "style-module--form--d4ac5";
export var icon = "style-module--icon--57766";
export var input = "style-module--input--03e2d";
export var panel = "style-module--panel--ebf0b";